import styles from './Assessment.module.css';
import { ChangeEvent, useEffect, useState } from 'react';
import { useAssessmentContext } from '@/libs/context/AssessmentContext';
import { validationPattern } from '@/libs/constants/validationPatten';
import { VerifyOtp } from '../leadForm/VerifyOtp';
import { AssessmentLoader } from './AssessmentLoader';
import Image from 'next/image';
import { AssessmentConfirmBox } from './AssessmentConfirmBox';
import { useGlobalContext } from '@/libs/context/GlobalContext';

type props = {
    questionList: any,
    isOtpVerified: boolean
}

export function AssessmentQuestion({ questionList, isOtpVerified }: props) {
    const [question, setQuestion] = useState(0);
    const [subQuestions, setSubQuestions] = useState(0);
    const [selectedOptions, setSelectedOptions] = useState<any>({});
    const { sendOtp, setFormIndex, loader, isConfirm, submitAssessmentForm, setApiError } = useAssessmentContext();
    const [phoneNo, setPhoneNo] = useState('');
    const [result, setResult] = useState<any>([]);
    const [otpPopup, setOtpPopup] = useState(false);
    const [error, setError] = useState('');
    const { props: { isMobileView } } = useGlobalContext();
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        const isValid = isAllowed(name, value)
        if (isValid) {
            setError('')
            setApiError!('')
            setPhoneNo(value)
        }
    }

    const isAllowed = (name: string, value: string) => {
        const Number = new RegExp(validationPattern.Number);
        return (value === '' || (Number.test(value)))
    }

    const checkValidation = () => {
        let _errors = error;
        let isValidate = true;
        if (!phoneNo || phoneNo.trim() === "" || phoneNo.length !== 10) {
            _errors = "Phone No is required";
            isValidate = false;
        }
        setError(_errors);
        return isValidate;
    }

    const submitData = async (e: any) => {
        e && e.preventDefault();
        if (checkValidation()) {
            await sendOtp?.(phoneNo)
        } else return;
    };

    useEffect(() => {
        if (isOtpVerified === true) {
            setOtpPopup(false)
        }
    }, [isOtpVerified])

    const otpVerified = (val: string) => {
        setOtpPopup(false)
        if (val === 'close') {
            setSubQuestions(subQuestions - 1);
        }
    };

    const handleChangeTwo = (QuestionId: number, QuestionType: string, Value: string | boolean, AnswerId?: number, IsNone?: number, Regex?: string) => {
        setError('')
        const updatedQuestionList = [...result];
        const questionToUpdate = updatedQuestionList[question].questions.find((f: any) => f.question_id === QuestionId);
        if (questionToUpdate && QuestionType === 'TEXT') {
            questionToUpdate.answer_text = Value;
            setResult(updatedQuestionList);
        } else if (questionToUpdate && (questionToUpdate.question_type === 'RADIO')) {
            const optionToUpdate = questionToUpdate.options.find((option: any) => option.answer_id === AnswerId);
            if (optionToUpdate) {
                optionToUpdate.correct_answer = Value;
                setSelectedOptions((prevState: any) => ({
                    ...prevState,
                    [QuestionId]: AnswerId
                }));
            }
            questionToUpdate.options.forEach((otherOption: any) => {
                if (otherOption.answer_id !== AnswerId) {
                    otherOption.correct_answer = false;
                }
            });
            setResult(updatedQuestionList);
        } else if (questionToUpdate && (questionToUpdate.question_type === 'RADIO_WITH_TEXT')) {
            const optionToUpdate = questionToUpdate.options.find((option: any) => option.answer_id === AnswerId);
            if (typeof Value === 'string') {
                const isCheckedYes = optionToUpdate.answer === 'Yes';
                if (isCheckedYes) {
                    optionToUpdate.answer_text = Value;
                }
            } else {
                if (optionToUpdate) {
                    optionToUpdate.correct_answer = Value;
                    setSelectedOptions((prevState: any) => ({
                        ...prevState,
                        [QuestionId]: AnswerId
                    }));
                }
                questionToUpdate.options.forEach((otherOption: any) => {
                    if (otherOption.answer_id !== AnswerId) {
                        otherOption.correct_answer = false;
                    }
                });
            }
            setResult(updatedQuestionList);
        }
        else if (questionToUpdate && questionToUpdate.question_type === 'CHECKBOX') {
            const optionToUpdate = questionToUpdate.options.find((option: any) => option.answer_id === AnswerId);
            if (optionToUpdate) {
                if (IsNone === 1) {
                    questionToUpdate.options.forEach((option: any) => {
                        option.correct_answer = option.answer_id === AnswerId;
                    });
                } else {
                    questionToUpdate.options.forEach((option: any) => {
                        option.is_none === 1 ? option.correct_answer = 'false' : ''
                    });
                    optionToUpdate.correct_answer = Value;
                }
            }
            setResult(updatedQuestionList);
        }
    };

    const handleNextClick = (e: any) => {
        if (questionList.length === question + 1 && questionList[question].questions.length === subQuestions + 1) {
            submitAssessmentForm!(result);
            setFormIndex!(4);
        } else {
            const currentQuestion = questionList[question].questions[subQuestions];
            let errorMessage = '';
            if (currentQuestion.question_type === 'TEXT' && currentQuestion.question_option_type === 'PHONE') {
                if (phoneNo.trim() === '') {
                    errorMessage = "Phone No is required";
                }
            }
            if (currentQuestion.question_type === 'TEXT' && currentQuestion.question_option_type != 'PHONE') {
                if (result[question].questions[subQuestions].answer_text.trim() === '') {
                    errorMessage = "Please fill this in";
                } else if (!(new RegExp(currentQuestion.regex.replaceAll('/', ''))).test(result[question].questions[subQuestions].answer_text)) {
                    errorMessage = "Please Enter a Valid Input";
                }
            }
            if (currentQuestion.question_type === 'RADIO') {
                const radioSelected = result[question].questions[subQuestions].options.some((option: any) => option.correct_answer);
                if (!radioSelected) {
                    errorMessage = "Please select an option";
                }
            }
            if (currentQuestion.question_type === 'RADIO_WITH_TEXT') {
                const radioSelected = result[question].questions[subQuestions].options.some((option: any) => option.correct_answer);
                const isSelectedYes = result[question].questions[subQuestions].options.find((option: any) => option.correct_answer == true);
                if (!radioSelected) {
                    errorMessage = "Please select an option";
                } else if (radioSelected && isSelectedYes.answer === "Yes" && isSelectedYes.answer_text === '') {
                    errorMessage = "Please Enter Details";
                }
            }
            if (currentQuestion.question_type === 'CHECKBOX') {
                const checkboxChecked = result[question].questions[subQuestions].options.some((option: any) => option.correct_answer);
                if (!checkboxChecked) {
                    errorMessage = "Please check at least one option";
                }
            }

            setError(errorMessage);

            if (errorMessage.length != 0) {
                return;
            }
            else {
                if (questionList[question].questions[subQuestions].question_option_type === 'PHONE') {
                    if (checkValidation()) {
                        // setOtpPopup(true);
                        setSubQuestions(subQuestions + 1);
                        submitData(e);
                        setPhoneNo('');
                    }
                } else if (questionList[question] && questionList[question].questions.length === subQuestions + 1) {
                    setQuestion(question + 1);
                    setSubQuestions(0);
                }
                else {
                    setSubQuestions(subQuestions + 1);
                }
            }
        }
    }

    const handlePrevClick = () => {
        if (subQuestions === 0) {
            if (question === 0) {
                setFormIndex!(2);
            } else {
                setQuestion(question - 1);
                setSubQuestions(questionList[question - 1].questions.length - 1);
            }
        } else {
            setSubQuestions(subQuestions - 1);
        }
    }

    useEffect(() => {
        setResult(questionList)
    }, [questionList])

    if (loader) { return <AssessmentLoader /> }
    else return <div className={`${styles.main_step_form} mt50`}>
        {isConfirm && <AssessmentConfirmBox />}
        {otpPopup && <VerifyOtp isAssessment={true} otpVerified={otpVerified} />}
        <div className="container" style={{ display: `${otpPopup === true ? 'none' : ''}` }}>
            <div className={styles.step_tab_top}>
                {questionList && questionList.map((f: any, idx: any) =>
                    <div className={`${styles.parentstep} ${(isMobileView ? idx === question : idx <= question) ? styles.active : ''}`} key={idx}>
                        <div className={styles.sub_step_assessment}>
                            <div className={styles.count_step}>
                                <span>{idx + 1}</span>
                            </div>
                            <div className={styles.sub_step_text}>
                                <h5 className="text666 font16 fontMedium">{f.segment_name}</h5>
                                <ul className={styles.sub_progess}>
                                    {f.questions && f.questions.map((f: any, idx2: number) =>
                                        <li className={(idx < question || (idx === question && idx2 <= subQuestions)) ? styles.active : ''} key={idx2}></li>
                                    )}
                                </ul>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <div className={styles.step_parent_details}>
                {questionList && questionList[0] && questionList[question].questions.map((f: any, idx: any) =>
                    <div className={`${styles.sub_form_details} ${idx === subQuestions && styles.active}`} key={idx}>
                        <div className={styles.heading_form}>
                            <h3 className="text333 font25 fontMedium mb30">{f.question}{f.is_mandatary === 1 && <sup className="textff0000">*</sup>}</h3>
                        </div>
                        {f.question_type === 'TEXT' && f.question_option_type === 'PHONE' &&
                            <div className={`${styles.form_group} ${error !== '' && styles.filled_required}`}>
                                <input type="tel" placeholder={f.placeholder} required value={phoneNo} style={{ fontFamily: 'unset' }} maxLength={10} autoComplete='off' onChange={(e) => (handleChange(e), handleChangeTwo(f.question_id, f.question_type, e.target.value))} />
                                {error !== '' &&
                                    <p className="font14 textff0000">
                                        <Image src="assets/images/required.svg" alt="required" height={14} width={14} style={{ marginRight: "8px" }} />
                                        {error}
                                    </p>
                                }
                            </div>
                        }
                        {f.question_option_type !== 'PHONE' && f.question_type === 'TEXT' &&
                            <div className={`${styles.form_group} ${error !== '' && styles.filled_required}`}>
                                <input type="text" autoComplete='OFF' value={f.answer_text} placeholder={f.placeholder} required style={{ fontFamily: 'unset' }} maxLength={100}
                                    onChange={(e) => handleChangeTwo(f.question_id, f.question_type, e.target.value, 0, 0, f.regex)}
                                />
                                {error !== '' &&
                                    <p className="font14 textff0000">
                                        <Image src="assets/images/required.svg" alt="required" height={14} width={14} style={{ marginRight: "8px" }} />
                                        {error}
                                    </p>
                                }
                            </div>
                        }
                        {f.question_option_type !== 'PHONE' && (f.question_type === 'RADIO') &&
                            <>
                                {f.options && f.options.map((m: any, idx: number) => {
                                    const isChecked = m.answer_id === selectedOptions[f.question_id];
                                    return (
                                        <div className={`${styles.form_radio_group} ${error !== '' && styles.filled_required}`} key={idx}>
                                            <input type="radio"
                                                id={m.answer}
                                                name={`selector_${f.question_id}`} // Use a unique name for each question
                                                checked={isChecked}
                                                onChange={(e) => handleChangeTwo(f.question_id, f.question_type, e.target.checked, m.answer_id)} />
                                            <label htmlFor={m.answer}>{m.answer}</label>
                                        </div>
                                    )
                                })}
                                {error !== '' &&
                                    <p className="font14 textff0000">
                                        <Image src="assets/images/required.svg" alt="required" height={14} width={14} style={{ marginRight: "8px" }} />
                                        {error}
                                    </p>
                                }
                            </>
                        }
                        {f.question_option_type !== 'PHONE' && (f.question_type === 'RADIO_WITH_TEXT') &&
                            <>
                                {f.options && f.options.map((m: any, idx: number) => {
                                    const isChecked = m.answer_id === selectedOptions[f.question_id];
                                    return (
                                        <div className={`${styles.form_radio_group} ${error !== '' && styles.filled_required}`} key={idx}>
                                            <input type="radio"
                                                id={m.answer}
                                                name={`selector_${f.question_id}`} // Use a unique name for each question
                                                checked={isChecked}
                                                onChange={(e) => handleChangeTwo(f.question_id, f.question_type, e.target.checked, m.answer_id)} />
                                            <label htmlFor={m.answer}>{m.answer}</label>
                                        </div>
                                    )
                                })}
                                {f.options && f.options.filter((f: any) => f.correct_answer === true) && f.options.filter((f: any) => f.correct_answer === true).map((m: any, idx: number) => {
                                    return (
                                        <div className={`${styles.form_group} ${styles.extrafiled} ${m.answer === 'Yes' ? styles.show : styles.hide}`} key={idx}>
                                            <textarea
                                                placeholder="Enter your medicine Information"
                                                value={m.answer_text}
                                                rows={3}
                                                onChange={(e) => handleChangeTwo(f.question_id, f.question_type, e.target.value, m.answer_id)}
                                            />
                                        </div>
                                    )
                                })}
                                {error !== '' &&
                                    <p className="font14 textff0000">
                                        <Image src="assets/images/required.svg" alt="required" height={14} width={14} style={{ marginRight: "8px" }} />
                                        {error}
                                    </p>
                                }
                            </>
                        }

                        {
                            f.question_option_type !== 'PHONE' && f.question_type === 'CHECKBOX' &&
                            <>
                                {f.options && f.options.map((m: any, idx: number) => {
                                    const isChecked = m.correct_answer === true || m.correct_answer === 'true';
                                    return (
                                        <div className={`${styles.form_radio_group} ${error !== '' && styles.filled_required}`} key={idx}>
                                            <input type="checkbox"
                                                id={m.answer}
                                                name="selector"
                                                checked={isChecked}
                                                onChange={(e) => {
                                                    handleChangeTwo(f.question_id, f.question_type, e.target.checked, m.answer_id, m.is_none);
                                                }} />
                                            <label htmlFor={m.answer}>{m.answer}</label>
                                        </div>
                                    )
                                }
                                )}
                                {error !== '' &&
                                    <p className="font14 textff0000">
                                        <Image src="assets/images/required.svg" alt="required" height={14} width={14} style={{ marginRight: "8px" }} />
                                        {error}
                                    </p>
                                }
                            </>
                        }
                    </div>
                )}
            </div>
            <div className={styles.next_btn_group}>
                <button className="btn text333" id="prev" onClick={handlePrevClick}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10" fill="none">
                        <path d="M6.5 0.5L1.5 5L6.5 9.5" stroke="#414042" />
                    </svg>
                    Previous
                </button>
                <button className="btn text333" id="next" onClick={handleNextClick}>
                    Next
                    <svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10" fill="none">
                        <path d="M0.5 0.5L5.5 5L0.5 9.5" stroke="#414042" />
                    </svg>
                </button>
            </div>
        </div>
    </div>
}
